import googleAnalytics from './services/google.analytics.service';

const servicesModule = angular.module('journey-ui.services', [])
  .factory('googleAnalytics', googleAnalytics);

export default servicesModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/services/index.js